//评论标签映射
export const commentTagMap = {
  TOP: '置顶',
  GOOD: '好评',
  GOD: '神评',
  HOT: '热评',
};

//https://doc.myoas.com/pages/viewpage.action?pageId=147862784#space-menu-link-content
export const commentErrorCode = {
  1005: '服务异常，请稍后重试',
  1017: '评论成功',
  1401: '服务异常，请稍后重试',
  1403: '登录过期',
  1500: '服务异常，请稍后重试',
  1504: '第三方资源请求超时',
  10001: '内容已失效，无法评论',
  10002: '点赞太频繁，请稍后重试',
  10003: '该内容禁止评论',
  10004: '操作频繁，请稍后重试',
  10005: '您的账号被封禁，无法发表评论',
  10006: '评论已删除',
};

//https://doc.myoas.com/pages/viewpage.action?pageId=85598895 0=文字，1=图文, 2=短视频, 3=图集 ，4=小视频,

export const contentTypeMap = {
  0: '文字',
  1: '图文',
  2: '短视频',
  3: '图集',
  4: '小视频',
};

export const commonSdkContentTypeMap = {
  0: 'article',
  2: 'video',
  4: 'smallVideo',
};

export const commonSdkStyleMap = {
  1: 'wutu_news',
  2: 'zuowenyoutu_news',
  4: 'santu_news',
  5: 'datu_news',
  6: 'datu_video_news',
};

export const feedsErrorCode = {
  1005: '服务异常，请稍后重试',
  1017: '评论成功',
  1400: '请求参数错误',
  1401: '服务异常，请稍后重试',
  1403: 'Session过期',
  1500: '服务异常，请稍后重试',
  1504: '第三方资源请求超时',
  10001: '内容已失效，无法评论',
  10002: '评论太长，请重新编辑',
  10003: '该内容禁止评论',
  10004: '操作频繁，请稍后重试',
  10005: '您的账号被封禁，无法发表评论',
  10006: '评论已删除',
};
